const evidence = document.querySelectorAll('.evidence');

const evidenceToggle = () => {
  if (!evidence) {
    return;
  }

  evidence.forEach((e) => {
    e.addEventListener('click', () => {
      e.classList.toggle('evidence--unblurred');
    });
  });
};

export default evidenceToggle;
